export class CacheConstants {
  static DTV_CATALOG = 'dtvcatalog';
  static LOGIN = 'login';
  static COLOR_FOR_PRODUCTS = 'coloursForProducts';
  static SALES_OFFER = 'salesOffer';
  static PLANNED_MAINTENANCE = 'plannedMaintenance';
}
